<div class="dialog-body">
    @if(isLoad){
    <table class="dp-table">
        <thead class="dp-table-header">
            <tr>
                <th>Worker Name</th>
                <th>Worker FC</th>
                <th>Worker Country</th>
                <th>DP Count</th>
                <th>Count Checked</th>
                <th>SP Count</th>
                <th>Count Checked</th>
                <th>Received By</th>
                <th>Received On</th>
            </tr>
        </thead>
        <tbody class="dp-table-body">
            <tr *ngFor="let i of [].constructor(10)">
                <td *ngFor="let j of [].constructor(9)">
                    <dp-loader></dp-loader>
                </td>
            </tr>
        </tbody>
    </table>
    } @else{
    @if(detailedReport.length ==0 && !isLoad){
    <div class="noData">
        <div class="placeholderTable"></div>
        <p>No data found!</p>
    </div>
    }
    @else {
    <div class="dp-table-scroll">
        <table class="dp-table">
            <thead class="dp-table-header">
                <tr>
                    <th>Worker Name</th>
                    <th>Worker FC</th>
                    <th>Worker Country</th>
                    <th>DP Count</th>
                    <th>Count Checked</th>
                    <th>SP Count</th>
                    <th>Count Checked</th>
                    <th>Received By</th>
                    <th>Received On</th>
                </tr>
            </thead>

            <tbody class="dp-table-body">
                @for (row of detailedReport; track row) {
                <tr [ngClass]="{ expanded: row.isExpanded }">
                    <td>{{row.workerFullName}}</td>
                    <td>{{ row.workerFc }}</td>
                    <td>{{ row.workerCountry }}</td>
                    <td>{{row.dpCount}}</td>
                    <td>{{row.dpCountChecked ? 'Checked' : 'Not Checked'}}</td>
                    <td>{{row.spCount}}</td>
                    <td>{{row.spCountChecked ? 'Checked' : 'Not Checked'}}</td>
                    <td>{{data.userName}}</td>
                    <td>{{row.receivingDate | date}}</td>
                </tr>
                }
            </tbody>
        </table>
    </div>
    }
    }
</div>